export default {
    rateTables: [],
    rateTable: {},
    rate: {},
    activeRateId: 0,
    totalItems: null,
    totalPage: null,
}